<script setup>
import { ref, computed, onBeforeUnmount, onMounted } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

const emit = defineEmits(['closeModal', 'chosenItems'])

const translaterStore   = useTranslaterStore()
const getTranslate      = computed(() => translaterStore.getTranslate)

const props = defineProps({
    list: {
        type: Object,
        required: true
    }
})

const showChosenList    = ref(false)
const chosenFinderText  = ref('')
const chosenItems       = ref({})
const filteredList      = ref({})

function focusToInput() {

    document.querySelector('.kan-chosen__selected-input').focus()
}

function findItems(input) {

    if(input && input.length > 2) {

        showChosenList.value = true

        let str = input.replace(/[&\\#,+()$~%.'":*?<>{}]/g, '')

        const re = new RegExp(str, 'gi')

        const filtered = {}

        for( let item in props.list ) {

            if (props.list[item].nameLocal.match(re) !== null) {

                filtered[item] = props.list[item]
            }
        }

        if(Object.keys(filtered).length == 0) showChosenList.value = false

        filteredList.value = filtered

    } else {

        filteredList.value = props.list
    }
}

function selectItem(item, index) {

    if(!(index in chosenItems.value)) {
        chosenItems.value[index] = item
    }

    showChosenList.value = false
    chosenFinderText.value = ''
    findItems()

    emit('chosenItems', chosenItems.value)
}

function removeItem(index) {

    delete chosenItems.value[index]
}

function clickListener(event) {

    let chosenBlock     = document.querySelector('.kan-chosen'),
        itsChosenBlock  = chosenBlock.contains(event.target)

    if (!itsChosenBlock && showChosenList.value) {
        showChosenList.value = false
    }
}

onMounted(() => {

    filteredList.value = props.list
    document.addEventListener('click', clickListener)
})

onBeforeUnmount(() => {

    document.removeEventListener('click', clickListener, false)
})

</script>

<template>
    <div class="kan-chosen">
        <ul class="kan-chosen__selected" @click="focusToInput($event)">
            <li 
                class="kan-chosen__selected-item"
                v-for="(chosenItem, index) of chosenItems" 
                :key="index"
                :data-unit="getTranslate[chosenItem.unit]"
                :data-id="chosenItem.id"
            >
                {{ chosenItem.nameLocal }} 
                <span 
                    class="material-icons kan-chosen__selected-item-delete" 
                    @click="removeItem(index)"
                >
                    close
                </span>
            </li>
            <li class="kan-chosen__selected-item kan-chosen__selected-item--finder">
                <input 
                    type="text" 
                    class="kan-chosen__selected-input" 
                    @focus="showChosenList = true"
                    @input="findItems($event.target.value)"
                    v-model="chosenFinderText"
                    size="1"
                    onkeydown="size=value.length || 1"
                    onkeyup="onkeydown()" 
                    onkeypress="onkeydown()" 
                    onchange="onkeydown()"
                >
            </li>
        </ul>
        <ul class="kan-chosen__list" :class="{ 'kan-chosen__list--show' : showChosenList }">
            <li 
                class="kan-chosen__list-item" 
                v-for="(item, index) of filteredList" 
                :key="index" 
                :data-unit="getTranslate[item.unit] || item.unit"
                @click="selectItem(item, index)"
            >
                {{ item.nameLocal }}
            </li>
        </ul>
    </div>
</template>

<style lang="scss">

* {

    box-sizing: border-box;
}

.kan-chosen {

    position: relative;

    &__selected {

        margin: 0;
        padding: 1px;
        display: flex;
        align-items: center;
        background: #fbfbfb;
        flex-wrap: wrap;
        font-size: 16px;
        border: 1px solid #C8C9C7;
        border-radius: 5px;
        list-style: none;
        cursor: text;
        min-height: 60px;

        @media (max-width: 991px) {

            height: 50px;
        }
 
        &-item {

            min-height: 40px;
            padding: 4px 12px;
            margin: 2px;
            display: flex;
            align-items: center;
            background: #e2e2e1;
            color: #000;
            border-radius: 3px;
            cursor: pointer;

            &--finder {

                background: transparent;
                border: 0;
                padding-left: 0;
                cursor: text;
            }

            &-delete {

                margin-left: 6px;
                font-size: 14px !important
            }
        }

        &-input {

            background: none;
            border: 0;
            outline: 0;
            color: #494a47;
        }
    }

    &__list {
        
        display: none;
        margin: 2px 0 0;
        padding: 5px 0;
        width: 100%;
        height: auto;
        max-height: 316px;
        
        list-style: none;
        background: #fbfbfb;
        font-size: 16px;
        border: 1px solid #C8C9C7;
        border-radius: 5px;

        overflow-y: scroll;

        position: absolute;
        z-index: 1000;

        &--show {

            display: block;
        }

        &-item {

            cursor: pointer;
            min-height: 30px;
            padding: 5px 36px 5px 16px;
            display: flex;
            align-items: center;

            &:hover {

                background: #f0f0f0;
            }
        }
    }
}

</style>